import {
  DEFAULT_CRAFTSMAN_QUALITY,
  Improvements,
  ManufacturedHomeFoundation,
  PositiveInt,
  Site,
  Transaction,
} from '@aloft/toolkit-shared';

import { ObjectiveCharacteristicsFormOutput } from '../../../../modules/analysis/schObjectiveCharacteristics.ts';

const outputImprovementFields: (keyof Improvements)[] = [
  'adu',
  'age',
  'attic',
  'barn',
  'basement',
  'carport',
  'deck',
  'fireplace',
  'fullBaths',
  'garage',
  'detachedGarage',
  'gla',
  'halfBaths',
  'manualCost',
  'manualCostDisplayName',
  'patio',
  'pool',
  'porch',
  'shed',
  'spa',
  'craftsmanQuality',
  'uadCondition',
  'uadQuality',
  'workshop',
  'propertyType',
];

type OutputImprovements = Pick<Improvements, (typeof outputImprovementFields)[number]> & {
  foundation?: ManufacturedHomeFoundation;
  numberOfUnits?: PositiveInt;
};

const outputSiteFields: (keyof Site)[] = ['area', 'location', 'view', 'notes'];
type OutputSite = Pick<Site, (typeof outputSiteFields)[number]>;

const outputTransactionFields: (keyof Transaction)[] = [
  'concessions',
  'contractDate',
  'price',
  'saleDate',
  'status',
  'termsOfSale',
  'expirationDate',
  'withdrawalDate',
  'daysOnMarket',
  'originalListPrice',
];

type OutputTransaction = Pick<Transaction, (typeof outputTransactionFields)[number]>;

export const objectiveCharacteristicsFormToEditableData = (
  objectiveCharacteristicsForm: ObjectiveCharacteristicsFormOutput,
): {
  improvements: OutputImprovements;
  site: OutputSite;
  transaction: OutputTransaction;
} => {
  const improvements = {} as OutputImprovements;
  const site = {} as OutputSite;
  const transaction = {} as OutputTransaction;

  Object.entries(objectiveCharacteristicsForm).forEach(([key, value]) => {
    // eslint-disable-next-line no-param-reassign
    if (key === 'uadQuality' && !value) value = DEFAULT_CRAFTSMAN_QUALITY;

    if (
      outputImprovementFields.includes(key as keyof Improvements) ||
      key === 'foundation' ||
      key === 'numberOfUnits'
    ) {
      // @ts-expect-error - Temporary until this is fixed
      improvements[key] = value;
    } else if (outputSiteFields.includes(key as keyof Site)) {
      // @ts-expect-error - Temporary until this is fixed
      site[key] = value;
    } else if (outputTransactionFields.includes(key as keyof Transaction)) {
      // @ts-expect-error - Temporary until this is fixed
      transaction[key] = value;
    }
  });

  return { improvements, site, transaction };
};
